export const color = {
  primary: "#b7ab98",
  secondary: "#000000",
};
